import type { MarketingAutomaticoModel } from "../models/marketingAutomaticoModel"
import { MarketingAutomaticoActionsTypes, type MarketingAutomaticoAction } from "./marketingAutomaticoActions"

export function marketingAutomaticoReducer(
    state: MarketingAutomaticoModel,
    action: MarketingAutomaticoAction
): MarketingAutomaticoModel {
    switch (action.type) {
        case MarketingAutomaticoActionsTypes.CARREGAR:
            return { ...state, lista: action.payload }

        case MarketingAutomaticoActionsTypes.ADICIONAR_OU_ATUALIZAR: {
            const existe = state.lista.some(i => i.id === action.payload.id)
            if (existe) {
                return {
                    ...state,
                    lista: state.lista.map(i => (i.id === action.payload.id ? action.payload : i)),
                }
            }
            return { ...state, lista: [...state.lista, action.payload] }
        }

        case MarketingAutomaticoActionsTypes.REMOVER:
            return { ...state, lista: state.lista.filter(i => i.id !== action.payload) }

        default:
            return state
    }
}
